/**
 * @generated SignedSource<<b831f3cf3d4ef7c53f27a796081f7033>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type TransferAppConfirmationModalQuery$variables = {
  id: string;
};
export type TransferAppConfirmationModalQuery$data = {
  readonly viewer: {
    readonly appById: {
      readonly slug: string;
    } | null;
  };
};
export type TransferAppConfirmationModalQuery = {
  response: TransferAppConfirmationModalQuery$data;
  variables: TransferAppConfirmationModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TransferAppConfirmationModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "App",
            "kind": "LinkedField",
            "name": "appById",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "QueryRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TransferAppConfirmationModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "App",
            "kind": "LinkedField",
            "name": "appById",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "62712da7d5bfe9a87f3f4ec260ee8635",
    "id": null,
    "metadata": {},
    "name": "TransferAppConfirmationModalQuery",
    "operationKind": "query",
    "text": "query TransferAppConfirmationModalQuery(\n  $id: ID!\n) {\n  viewer {\n    appById(id: $id) {\n      slug\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "024420b0cccf75ddd5ae74f872583ad1";

export default node;
